module.exports = __webpack_public_path__ + "static/media/IMG_2726.42d3f6ad.jpg";